import { FC, useEffect, useContext, createContext, } from "react";
import { ProForm } from '../../antd';
import { FormInstance } from "antd/lib/form";
import MainSubEdiTableContext, { IEdiTableContext } from '../context';

export const EditableRowContext = createContext<FormInstance<any> | undefined>(
  undefined,
);

const EditableRow: FC<any> = props => {
  const { onValuesChange, record, ...restProps } = props;
  const {dispatchEdiTable, dataSource } = useContext<IEdiTableContext>(MainSubEdiTableContext);
  const [form] = ProForm.useForm();
  const dataRowKey = props['data-row-key'];
  useEffect(() => {
    dispatchEdiTable('addForm', { form, record: record });
    return () => {
      dispatchEdiTable('deleteForm', { record: record });
    };
  }, []);
  const handleValuesChange = (changedValues: any, values: any) => {
    const findItem = dataSource?.find?.(v => v.key === dataRowKey);
    onValuesChange?.(
      Object.values(changedValues)[0],
      changedValues,
      { ...findItem, ...values },
      dataRowKey,
      form,
    );
  };
  if (dataRowKey === undefined) return <tr {...props}></tr>;
  return (
    <ProForm
      form={form}
      name={`mianSubEdiTable_${dataRowKey}`}
      component={false}
      onValuesChange={handleValuesChange}
    >
      <EditableRowContext.Provider value={form}>
        <tr {...restProps}></tr>
      </EditableRowContext.Provider>
    </ProForm>
  );
};

export default EditableRow;